import React, { FC, useState } from "react";
import { StandardContextProps } from "@/types/contextTypes";
import { AppColorsContext } from "@/contexts/AppColors/AppColorsContext";
import { darkModeColors, lightModeColors } from "@/css/colors";

export const AppColorsContextProvider: FC<StandardContextProps> = ({
  children,
}) => {
  const [isDarkMode, setIsDarkMode] = useState<boolean>(false);
  const colors = isDarkMode ? darkModeColors : lightModeColors;

  return (
    <AppColorsContext.Provider value={{ isDarkMode, setIsDarkMode, colors }}>
      {children}
    </AppColorsContext.Provider>
  );
};
